import { apiSlice } from '../../api/apiSlice';
import * as constants from '../../constants';

export const CoachingInsightSlice = apiSlice.injectEndpoints({
    endpoints: (builder: any) => ({
        getCoachingInsightSummary: builder.query({
            query: (arg: any) => {
                const { agentNumber, fromDate, toDate, isCurrentWeek, parentClientId } = arg;
                return {
                    url: constants.GET_COACHING_INSIGHT_SUMMARIES,
                    params: {
                        agentNumber,
                        fromDate,
                        toDate,
                        isCurrentWeek,
                        parentClientId
                    },
                };
            },
            // providesTags: ['coaching_insight'],
        }),
        getCoachingInsightFeedback: builder.query({
            query: (arg: any) => {
                const { coachingInsightId,authorNumber } = arg;
                return {
                    url: constants.GET_COACHING_INSIGHT_FEEDBACK,
                    params: { coachingInsightId,authorNumber },
                };
            },
            providesTags: ['coaching_insight'],
        }),
        createCoachingInsightFeedback: builder.mutation({
            query: (data: any) => ({
                url: constants.CREATE_COACHING_INSIGHT_FEEDBACK,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['coaching_insight'],
        }),
        getConfigSwitchForEmployee : builder.query({
            query: (arg: any) => {
                const { employeeNumber, config } = arg;
                return {
                    url: constants.GET_CONFIG_SWITCH_FOR_EMPLOYEE,
                    params: {
                        employeeNumber,
                        config,
                    },
                };
            },
        }),
        getAllConfigSwitchesForEmployee: builder.query({
            query: (employeeNumber: string) => {
                return {
                    url: constants.GET_ALL_CONFIG_SWITCHES_FOR_EMPLOYEE,
                    params: {
                        employeeNumber,
                    },
                };
            },
        }),
        getCoachingInsightHistory: builder.query({
            query: (arg: any) => {
                const { employeeNumber, fromDate } = arg;
                return {
                    url: constants.GET_COACHING_INSIGHT_HISTORY,
                    params: {
                        employeeNumber,
                        fromDate,
                    },
                };
            },
            providesTags: ['coachingInsightHistory'],
        }),
        getCoachingInsightFeedbackDetails: builder.query({
            query: (arg: any) => {
                const params = new URLSearchParams();
                if (arg.agentNumber && arg.agentNumber.length > 0) arg.agentNumber.forEach((id: any) => params.append('agentNumber', id));
                params.append('fromDate', arg.fromDate);
                params.append('authorNumber', arg.authorNumber);
                return `${constants.GET_COACHING_INSIGHT_FEEDBACK_DETAILS}?${params.toString()}`;
            },
            providesTags: ['coaching_insight'],
        }),
        getInsightCallDetails: builder.query({
            query: (arg: any) => {
                const { agentNumber, fromDate, toDate } = arg;
                return {
                    url: constants.GET_INSIGHT_CALL_DETAILS,
                    params: {
                        agentNumber,
                        fromDate,
                        toDate,
                    },
                };
            },
        }),
        getCoachingInsightConfig: builder.query({
            query: (arg: any) => {
                const { parentClientId } = arg;
                return {
                    url: constants.GET_COACHING_INSIGHT_CONFIG,
                    params: {
                        parentClientId,
                    },
                };
            },
        }),
    }),
});

export const {
    useGetCoachingInsightSummaryQuery,
    useGetCoachingInsightFeedbackQuery,
    useCreateCoachingInsightFeedbackMutation,
    useGetConfigSwitchForEmployeeQuery,
    useGetAllConfigSwitchesForEmployeeQuery,
    useGetCoachingInsightHistoryQuery,
    useGetCoachingInsightFeedbackDetailsQuery,
    useGetInsightCallDetailsQuery,
    useGetCoachingInsightConfigQuery,
} = CoachingInsightSlice;
